import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSecurityOverview = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_38224_3351)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M11.0833 0.583008H2.91667C1.30842 0.583008 0 1.89142 0 3.49967V10.4997C0 12.1079 1.30842 13.4163 2.91667 13.4163H11.0833C12.6916 13.4163 14 12.1079 14 10.4997V3.49967C14 1.89142 12.6916 0.583008 11.0833 0.583008ZM2.91667 1.74967H11.0833C12.0482 1.74967 12.8333 2.53484 12.8333 3.49967V4.66634H1.16667V3.49967C1.16667 2.53484 1.95183 1.74967 2.91667 1.74967ZM11.0833 12.2497H2.91667C1.95183 12.2497 1.16667 11.4645 1.16667 10.4997V5.83301H12.8333V10.4997C12.8333 11.4645 12.0482 12.2497 11.0833 12.2497ZM1.75 3.20801C1.75 2.72501 2.142 2.33301 2.625 2.33301C3.108 2.33301 3.5 2.72501 3.5 3.20801C3.5 3.69101 3.108 4.08301 2.625 4.08301C2.142 4.08301 1.75 3.69101 1.75 3.20801ZM4.08333 3.20801C4.08333 2.72501 4.47533 2.33301 4.95833 2.33301C5.44133 2.33301 5.83333 2.72501 5.83333 3.20801C5.83333 3.69101 5.44133 4.08301 4.95833 4.08301C4.47533 4.08301 4.08333 3.69101 4.08333 3.20801ZM5.25 9.33301V10.4997C5.25 10.8223 4.98867 11.083 4.66667 11.083C4.34467 11.083 4.08333 10.8223 4.08333 10.4997V9.33301C4.08333 9.01042 4.34467 8.74967 4.66667 8.74967C4.98867 8.74967 5.25 9.01042 5.25 9.33301ZM7.58333 7.58301V10.4997C7.58333 10.8223 7.322 11.083 7 11.083C6.678 11.083 6.41667 10.8223 6.41667 10.4997V7.58301C6.41667 7.26042 6.678 6.99967 7 6.99967C7.322 6.99967 7.58333 7.26042 7.58333 7.58301ZM9.91667 8.74967V10.4997C9.91667 10.8223 9.65533 11.083 9.33333 11.083C9.01133 11.083 8.75 10.8223 8.75 10.4997V8.74967C8.75 8.42709 9.01133 8.16634 9.33333 8.16634C9.65533 8.16634 9.91667 8.42709 9.91667 8.74967Z",
				fill: "currentColor"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_38224_3351",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 14,
				height: 14,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgSecurityOverview);
export default ForwardRef;
